export const indiaLogo = `
<svg xmlns="http://www.w3.org/2000/svg" width="26" height="58" viewBox="0 0 26 60" fill="none">
    <g clip-path="url(#clip0_16172_90068)">
    <path d="M0 8C0 3.58172 3.58172 0 8 0H26V60H8C3.58172 60 0 56.4183 0 52V8Z" fill="#F5F5F5"/>
    <circle cx="13.125" cy="22.75" r="0.875" fill="#0059A3"/>
    <circle cx="13.125" cy="22.75" r="4.6875" stroke="#0059A3" stroke-width="0.625"/>
    <circle cx="12.5539" cy="18.4118" r="0.25" transform="rotate(-7.5 12.5539 18.4118)" fill="#0059A3"/>
    <circle cx="13.6965" cy="27.0869" r="0.25" transform="rotate(-7.5 13.6965 27.0869)" fill="#0059A3"/>
    <circle cx="17.1675" cy="24.4236" r="0.25" transform="rotate(112.5 17.1675 24.4236)" fill="#0059A3"/>
    <circle cx="9.08352" cy="21.0751" r="0.25" transform="rotate(112.5 9.08352 21.0751)" fill="#0059A3"/>
    <circle cx="16.5964" cy="20.086" r="0.25" transform="rotate(52.5 16.5964 20.086)" fill="#0059A3"/>
    <circle cx="9.65307" cy="25.4127" r="0.25" transform="rotate(52.5 9.65307 25.4127)" fill="#0059A3"/>
    <circle cx="15.7883" cy="19.2784" r="0.25" transform="rotate(37.5 15.7883 19.2784)" fill="#0059A3"/>
    <circle cx="10.4622" cy="26.2202" r="0.25" transform="rotate(37.5 10.4622 26.2202)" fill="#0059A3"/>
    <circle cx="14.7984" cy="26.7913" r="0.25" transform="rotate(157.5 14.7984 26.7913)" fill="#0059A3"/>
    <circle cx="11.4507" cy="18.7074" r="0.25" transform="rotate(157.5 11.4507 18.7074)" fill="#0059A3"/>
    <circle cx="17.4617" cy="23.3203" r="0.25" transform="rotate(97.5 17.4617 23.3203)" fill="#0059A3"/>
    <circle cx="8.78787" cy="22.1782" r="0.25" transform="rotate(97.5 8.78787 22.1782)" fill="#0059A3"/>
    <circle cx="14.7994" cy="18.7074" r="0.25" transform="rotate(22.5 14.7994 18.7074)" fill="#0059A3"/>
    <circle cx="11.4498" cy="26.7914" r="0.25" transform="rotate(22.5 11.4498 26.7914)" fill="#0059A3"/>
    <circle cx="15.7881" cy="26.2202" r="0.25" transform="rotate(142.5 15.7881 26.2202)" fill="#0059A3"/>
    <circle cx="10.462" cy="19.2784" r="0.25" transform="rotate(142.5 10.462 19.2784)" fill="#0059A3"/>
    <circle cx="17.4625" cy="22.1783" r="0.25" transform="rotate(82.5 17.4625 22.1783)" fill="#0059A3"/>
    <circle cx="8.78672" cy="23.3204" r="0.25" transform="rotate(82.5 8.78672 23.3204)" fill="#0059A3"/>
    <circle cx="13.6957" cy="18.4117" r="0.25" transform="rotate(7.5 13.6957 18.4117)" fill="#0059A3"/>
    <circle cx="12.5531" cy="27.0869" r="0.25" transform="rotate(7.5 12.5531 27.0869)" fill="#0059A3"/>
    <circle cx="16.5948" cy="25.4126" r="0.25" transform="rotate(127.5 16.5948 25.4126)" fill="#0059A3"/>
    <circle cx="9.65338" cy="20.0859" r="0.25" transform="rotate(127.5 9.65338 20.0859)" fill="#0059A3"/>
    <circle cx="17.1674" cy="21.0751" r="0.25" transform="rotate(67.5 17.1674 21.0751)" fill="#0059A3"/>
    <circle cx="9.08345" cy="24.4236" r="0.25" transform="rotate(67.5 9.08345 24.4236)" fill="#0059A3"/>
    <g clip-path="url(#clip1_16172_90068)">
    <path d="M12.9555 27.106L12.8055 24.481L12.9555 23.231L13.1055 24.481L12.9555 27.106Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip2_16172_90068)">
    <path d="M13.0055 18.356L13.1555 20.981L13.0055 22.231L12.8555 20.981L13.0055 18.356Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip3_16172_90068)">
    <path d="M9.20353 20.522L11.5518 21.7045L12.5594 22.4595L11.4018 21.9644L9.20353 20.522Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip4_16172_90068)">
    <path d="M16.7574 24.9402L14.4091 23.7576L13.4016 23.0027L14.5591 23.4978L16.7574 24.9402Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip5_16172_90068)">
    <path d="M9.17853 24.897L11.3768 23.4545L12.5344 22.9595L11.5268 23.7144L9.17853 24.897Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip6_16172_90068)">
    <path d="M16.7824 20.5652L14.5841 22.0076L13.4266 22.5027L14.4341 21.7478L16.7824 20.5652Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip7_16172_90068)">
    <path d="M9.86874 25.8069L11.6188 23.8447L12.6088 23.0669L11.831 24.0569L9.86874 25.8069Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip8_16172_90068)">
    <path d="M16.0922 19.6551L14.3421 21.6173L13.3522 22.3951L14.13 21.4052L16.0922 19.6551Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip9_16172_90068)">
    <path d="M11.8724 18.4986L12.6967 20.9953L12.8754 22.2416L12.4069 21.073L11.8724 18.4986Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip10_16172_90068)">
    <path d="M14.0885 26.9634L13.2642 24.4667L13.0856 23.2205L13.554 24.389L14.0885 26.9634Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip11_16172_90068)">
    <path d="M8.7607 21.5745L11.3351 22.109L12.5037 22.5774L11.2574 22.3988L8.7607 21.5745Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip12_16172_90068)">
    <path d="M17.2002 23.8874L14.6259 23.3529L13.4573 22.8845L14.7035 23.0631L17.2002 23.8874Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip13_16172_90068)">
    <path d="M10.7705 26.5075L11.9531 24.1592L12.708 23.1517L12.2129 24.3092L10.7705 26.5075Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip14_16172_90068)">
    <path d="M15.1905 18.9547L14.0079 21.3031L13.253 22.3106L13.748 21.1531L15.1905 18.9547Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip15_16172_90068)">
    <path d="M10.8135 18.9296L12.2559 21.1279L12.751 22.2855L11.9961 21.2779L10.8135 18.9296Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip16_16172_90068)">
    <path d="M15.1455 26.5323L13.7031 24.334L13.208 23.1764L13.9629 24.184L15.1455 26.5323Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip17_16172_90068)">
    <path d="M8.60547 22.706L11.2305 22.556L12.4805 22.706L11.2305 22.856L8.60547 22.706Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip18_16172_90068)">
    <path d="M17.3555 22.756L14.7305 22.906L13.4805 22.756L14.7305 22.606L17.3555 22.756Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip19_16172_90068)">
    <path d="M11.8248 26.9505L12.3594 24.3761L12.8278 23.2075L12.6491 24.4537L11.8248 26.9505Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip20_16172_90068)">
    <path d="M14.1361 18.5116L13.6016 21.0859L13.1332 22.2545L13.3118 21.0083L14.1361 18.5116Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip21_16172_90068)">
    <path d="M9.90509 19.6197L11.8673 21.3698L12.6451 22.3598L11.6552 21.5819L9.90509 19.6197Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip22_16172_90068)">
    <path d="M16.0558 25.8423L14.0936 24.0922L13.3158 23.1023L14.3058 23.8801L16.0558 25.8423Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip23_16172_90068)">
    <path d="M8.74751 23.8391L11.2442 23.0148L12.4905 22.8362L11.3219 23.3046L8.74751 23.8391Z" fill="#0059A3"/>
    </g>
    <g clip-path="url(#clip24_16172_90068)">
    <path d="M17.2134 21.6228L14.7167 22.4471L13.4705 22.6257L14.639 22.1573L17.2134 21.6228Z" fill="#0059A3"/>
    </g>
    <path d="M7.23766 34.02V41H5.83766V34.02H7.23766ZM14.7909 41H13.3909L10.2209 36.21V41H8.82086V34.01H10.2209L13.3909 38.81V34.01H14.7909V41ZM18.8144 34.02C19.5477 34.02 20.191 34.1633 20.7444 34.45C21.3044 34.7367 21.7344 35.1467 22.0344 35.68C22.341 36.2067 22.4944 36.82 22.4944 37.52C22.4944 38.22 22.341 38.8333 22.0344 39.36C21.7344 39.88 21.3044 40.2833 20.7444 40.57C20.191 40.8567 19.5477 41 18.8144 41H16.3744V34.02H18.8144ZM18.7644 39.81C19.4977 39.81 20.0644 39.61 20.4644 39.21C20.8644 38.81 21.0644 38.2467 21.0644 37.52C21.0644 36.7933 20.8644 36.2267 20.4644 35.82C20.0644 35.4067 19.4977 35.2 18.7644 35.2H17.7744V39.81H18.7644Z" fill="#0059A3"/>
    </g>
    <defs>
    <clipPath id="clip0_16172_90068">
    <path d="M0 8C0 3.58172 3.58172 0 8 0H26V60H8C3.58172 60 0 56.4183 0 52V8Z" fill="white"/>
    </clipPath>
    <clipPath id="clip1_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(-1 0 0 1 13.7305 23.1685)"/>
    </clipPath>
    <clipPath id="clip2_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(1 0 0 -1 12.2305 22.2935)"/>
    </clipPath>
    <clipPath id="clip3_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(0.5 -0.866025 -0.866025 -0.5 12.2266 23.1619)"/>
    </clipPath>
    <clipPath id="clip4_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(-0.5 0.866025 0.866025 0.5 13.7344 22.3003)"/>
    </clipPath>
    <clipPath id="clip5_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(-0.5 -0.866025 -0.866025 0.5 12.9766 23.5994)"/>
    </clipPath>
    <clipPath id="clip6_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(0.5 0.866025 0.866025 -0.5 12.9844 21.8628)"/>
    </clipPath>
    <clipPath id="clip7_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 13.2012 23.5707)"/>
    </clipPath>
    <clipPath id="clip8_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(0.707107 0.707107 0.707107 -0.707107 12.7598 21.8914)"/>
    </clipPath>
    <clipPath id="clip9_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(0.965926 -0.258819 -0.258819 -0.965926 12.1426 22.5026)"/>
    </clipPath>
    <clipPath id="clip10_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(-0.965926 0.258819 0.258819 0.965926 13.8184 22.9595)"/>
    </clipPath>
    <clipPath id="clip11_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(0.258819 -0.965926 -0.965926 -0.258819 12.3633 23.3422)"/>
    </clipPath>
    <clipPath id="clip12_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(-0.258819 0.965926 0.965926 0.258819 13.5977 22.1198)"/>
    </clipPath>
    <clipPath id="clip13_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(-0.866025 -0.5 -0.5 0.866025 13.4121 23.485)"/>
    </clipPath>
    <clipPath id="clip14_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(0.866025 0.5 0.5 -0.866025 12.5488 21.9772)"/>
    </clipPath>
    <clipPath id="clip15_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(0.866025 -0.5 -0.5 -0.866025 12.1113 22.7271)"/>
    </clipPath>
    <clipPath id="clip16_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(-0.866025 0.5 0.5 0.866025 13.8477 22.7349)"/>
    </clipPath>
    <clipPath id="clip17_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(3.69127e-08 -1 -1 -3.69127e-08 12.543 23.481)"/>
    </clipPath>
    <clipPath id="clip18_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(-3.69127e-08 1 1 3.69127e-08 13.418 21.981)"/>
    </clipPath>
    <clipPath id="clip19_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(-0.965926 -0.258819 -0.258819 0.965926 13.5918 23.3478)"/>
    </clipPath>
    <clipPath id="clip20_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(0.965926 0.258819 0.258819 -0.965926 12.3691 22.1143)"/>
    </clipPath>
    <clipPath id="clip21_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 12.1406 22.952)"/>
    </clipPath>
    <clipPath id="clip22_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(-0.707107 0.707107 0.707107 0.707107 13.8203 22.5101)"/>
    </clipPath>
    <clipPath id="clip23_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(-0.258819 -0.965926 -0.965926 0.258819 12.752 23.5686)"/>
    </clipPath>
    <clipPath id="clip24_16172_90068">
    <rect width="1.5" height="4" fill="white" transform="matrix(0.258819 0.965926 0.965926 -0.258819 13.209 21.8933)"/>
    </clipPath>
    </defs>
</svg>`
;

export const indiaLogoV2 = `
<svg width="30" height="45" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="9.00001" cy="5.99611" r="1.01173" fill="#0059A3"/>
<circle cx="9.00008" cy="5.99617" r="5.42" stroke="#0059A3" stroke-width="0.722666"/>
<circle cx="8.33971" cy="0.985191" r="0.289067" transform="rotate(-7.5 8.33971 0.985191)" fill="#0059A3"/>
<circle cx="9.66026" cy="11.0155" r="0.289067" transform="rotate(-7.5 9.66026 11.0155)" fill="#0059A3"/>
<circle cx="13.6736" cy="7.93672" r="0.289067" transform="rotate(112.5 13.6736 7.93672)" fill="#0059A3"/>
<circle cx="4.32642" cy="4.06464" r="0.289067" transform="rotate(112.5 4.32642 4.06464)" fill="#0059A3"/>
<circle cx="13.0133" cy="2.92093" r="0.289067" transform="rotate(52.5 13.0133 2.92093)" fill="#0059A3"/>
<circle cx="4.98668" cy="9.08011" r="0.289067" transform="rotate(52.5 4.98668 9.08011)" fill="#0059A3"/>
<circle cx="12.0795" cy="1.98734" r="0.289067" transform="rotate(37.5 12.0795 1.98734)" fill="#0059A3"/>
<circle cx="5.9203" cy="10.0137" r="0.289067" transform="rotate(37.5 5.9203 10.0137)" fill="#0059A3"/>
<circle cx="10.9358" cy="10.6736" r="0.289067" transform="rotate(157.5 10.9358 10.6736)" fill="#0059A3"/>
<circle cx="7.06397" cy="1.32696" r="0.289067" transform="rotate(157.5 7.06397 1.32696)" fill="#0059A3"/>
<circle cx="14.0153" cy="6.66097" r="0.289067" transform="rotate(97.5 14.0153 6.66097)" fill="#0059A3"/>
<circle cx="3.98451" cy="5.34066" r="0.289067" transform="rotate(97.5 3.98451 5.34066)" fill="#0059A3"/>
<circle cx="10.936" cy="1.3269" r="0.289067" transform="rotate(22.5 10.936 1.3269)" fill="#0059A3"/>
<circle cx="7.06416" cy="10.6736" r="0.289067" transform="rotate(22.5 7.06416 10.6736)" fill="#0059A3"/>
<circle cx="12.0796" cy="10.014" r="0.289067" transform="rotate(142.5 12.0796 10.014)" fill="#0059A3"/>
<circle cx="5.92062" cy="1.98766" r="0.289067" transform="rotate(142.5 5.92062 1.98766)" fill="#0059A3"/>
<circle cx="14.0153" cy="5.33995" r="0.289067" transform="rotate(82.5 14.0153 5.33995)" fill="#0059A3"/>
<circle cx="3.98454" cy="6.66026" r="0.289067" transform="rotate(82.5 3.98454 6.66026)" fill="#0059A3"/>
<circle cx="9.66024" cy="0.985457" r="0.289067" transform="rotate(7.5 9.66024 0.985457)" fill="#0059A3"/>
<circle cx="8.33968" cy="11.0157" r="0.289067" transform="rotate(7.5 8.33968 11.0157)" fill="#0059A3"/>
<circle cx="13.0134" cy="9.07973" r="0.289067" transform="rotate(127.5 13.0134 9.07973)" fill="#0059A3"/>
<circle cx="4.98679" cy="2.92055" r="0.289067" transform="rotate(127.5 4.98679 2.92055)" fill="#0059A3"/>
<circle cx="13.6736" cy="4.06421" r="0.289067" transform="rotate(67.5 13.6736 4.06421)" fill="#0059A3"/>
<circle cx="4.32647" cy="7.93628" r="0.289067" transform="rotate(67.5 4.32647 7.93628)" fill="#0059A3"/>
<g clip-path="url(#clip0_26046_32588)">
<path d="M8.80385 11.0352L8.63042 8.00002L8.80385 6.55469L8.97729 8.00002L8.80385 11.0352Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip1_26046_32588)">
<path d="M8.86167 0.917906L9.03511 3.9531L8.86167 5.39844L8.68823 3.9531L8.86167 0.917906Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip2_26046_32588)">
<path d="M4.46648 3.42203L7.18175 4.78943L8.34673 5.6623L7.00831 5.08983L4.46648 3.42203Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip3_26046_32588)">
<path d="M13.1993 8.53109L10.484 7.1637L9.31904 6.29083L10.6575 6.86329L13.1993 8.53109Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip4_26046_32588)">
<path d="M4.43757 8.48069L6.97941 6.81288L8.31782 6.24042L7.15285 7.11329L4.43757 8.48069Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip5_26046_32588)">
<path d="M13.2282 3.47244L10.6864 5.14024L9.34795 5.7127L10.5129 4.83983L13.2282 3.47244Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip6_26046_32588)">
<path d="M5.23551 9.53288L7.25908 7.26403L8.40373 6.36466L7.50436 7.50931L5.23551 9.53288Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip7_26046_32588)">
<path d="M12.4303 2.42025L10.4067 4.6891L9.26204 5.58846L10.1614 4.44382L12.4303 2.42025Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip8_26046_32588)">
<path d="M7.55158 1.08233L8.50468 3.96921L8.71123 5.41019L8.16962 4.05899L7.55158 1.08233Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip9_26046_32588)">
<path d="M10.1144 10.8698L9.16133 7.98293L8.95478 6.54196L9.49639 7.89315L10.1144 10.8698Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip10_26046_32588)">
<path d="M3.95409 4.63962L6.93076 5.25766L8.28195 5.79927L6.84098 5.59272L3.95409 4.63962Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip11_26046_32588)">
<path d="M13.7117 7.31351L10.735 6.69547L9.38382 6.15386L10.8248 6.36041L13.7117 7.31351Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip12_26046_32588)">
<path d="M6.27848 10.3433L7.64587 7.62806L8.51874 6.46308L7.94628 7.8015L6.27848 10.3433Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip13_26046_32588)">
<path d="M11.3873 1.61076L10.0199 4.32604L9.14703 5.49102L9.71949 4.1526L11.3873 1.61076Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip14_26046_32588)">
<path d="M6.32839 1.58088L7.9962 4.12272L8.56866 5.46113L7.69579 4.29616L6.32839 1.58088Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip15_26046_32588)">
<path d="M11.3374 10.3713L9.66957 7.82943L9.09711 6.49102L9.96998 7.65599L11.3374 10.3713Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip16_26046_32588)">
<path d="M3.77435 5.94765L6.80955 5.77421L8.25488 5.94765L6.80955 6.12109L3.77435 5.94765Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip17_26046_32588)">
<path d="M13.8917 6.00547L10.8565 6.17891L9.41113 6.00547L10.8565 5.83203L13.8917 6.00547Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip18_26046_32588)">
<path d="M7.49558 10.8552L8.11361 7.87857L8.65522 6.52738L8.44867 7.96835L7.49558 10.8552Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip19_26046_32588)">
<path d="M10.1702 1.09789L9.55216 4.07455L9.01055 5.42575L9.2171 3.98478L10.1702 1.09789Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip20_26046_32588)">
<path d="M5.27645 2.37809L7.5453 4.40166L8.44466 5.5463L7.30002 4.64694L5.27645 2.37809Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip21_26046_32588)">
<path d="M12.3893 9.57406L10.1205 7.55049L9.22111 6.40584L10.3658 7.30521L12.3893 9.57406Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip22_26046_32588)">
<path d="M3.93902 7.25677L6.8259 6.30367L8.26688 6.09712L6.91568 6.63873L3.93902 7.25677Z" fill="#0059A3"/>
</g>
<g clip-path="url(#clip23_26046_32588)">
<path d="M13.7265 4.69538L10.8396 5.64848L9.39865 5.85503L10.7498 5.31342L13.7265 4.69538Z" fill="#0059A3"/>
</g>
<path d="M2.33363 14.7273V22H1.01616V14.7273H2.33363ZM9.73686 14.7273V22H8.56499L5.13814 17.0462H5.07777V22H3.7603V14.7273H4.93928L8.36257 19.6847H8.42649V14.7273H9.73686ZM13.6369 22H11.1724V14.7273H13.6866C14.4087 14.7273 15.0289 14.8729 15.5474 15.1641C16.0682 15.4529 16.4683 15.8684 16.7477 16.4105C17.027 16.9527 17.1667 17.6013 17.1667 18.3565C17.1667 19.1141 17.0259 19.7652 16.7441 20.3097C16.4648 20.8542 16.0611 21.272 15.5332 21.5632C15.0076 21.8544 14.3755 22 13.6369 22ZM12.4899 20.8601H13.573C14.0796 20.8601 14.5022 20.7678 14.8407 20.5831C15.1793 20.3961 15.4338 20.1179 15.6042 19.7486C15.7747 19.3769 15.8599 18.9129 15.8599 18.3565C15.8599 17.8002 15.7747 17.3385 15.6042 16.9716C15.4338 16.6023 15.1816 16.3265 14.8478 16.1442C14.5164 15.9595 14.1045 15.8672 13.612 15.8672H12.4899V20.8601Z" fill="#0059A3"/>
<path d="M26 24V0" stroke="#D6D6D6"/>
<defs>
<clipPath id="clip0_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(-1 0 0 1 9.69995 6.48242)"/>
</clipPath>
<clipPath id="clip1_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(1 0 0 -1 7.96558 5.4707)"/>
</clipPath>
<clipPath id="clip2_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(0.5 -0.866025 -0.866025 -0.5 7.96118 6.47461)"/>
</clipPath>
<clipPath id="clip3_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(-0.5 0.866025 0.866025 0.5 9.70459 5.47852)"/>
</clipPath>
<clipPath id="clip4_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(-0.5 -0.866025 -0.866025 0.5 8.82837 6.98047)"/>
</clipPath>
<clipPath id="clip5_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(0.5 0.866025 0.866025 -0.5 8.8374 4.97266)"/>
</clipPath>
<clipPath id="clip6_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 9.08838 6.94727)"/>
</clipPath>
<clipPath id="clip7_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(0.707107 0.707107 0.707107 -0.707107 8.57739 5.00586)"/>
</clipPath>
<clipPath id="clip8_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(0.965926 -0.258819 -0.258819 -0.965926 7.86426 5.71191)"/>
</clipPath>
<clipPath id="clip9_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(-0.965926 0.258819 0.258819 0.965926 9.80151 6.24023)"/>
</clipPath>
<clipPath id="clip10_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(0.258819 -0.965926 -0.965926 -0.258819 8.11987 6.68359)"/>
</clipPath>
<clipPath id="clip11_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(-0.258819 0.965926 0.965926 0.258819 9.5459 5.26953)"/>
</clipPath>
<clipPath id="clip12_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(-0.866025 -0.5 -0.5 0.866025 9.33105 6.84863)"/>
</clipPath>
<clipPath id="clip13_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(0.866025 0.5 0.5 -0.866025 8.33496 5.10547)"/>
</clipPath>
<clipPath id="clip14_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(0.866025 -0.5 -0.5 -0.866025 7.82886 5.97168)"/>
</clipPath>
<clipPath id="clip15_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(-0.866025 0.5 0.5 0.866025 9.83691 5.98047)"/>
</clipPath>
<clipPath id="clip16_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(3.69127e-08 -1 -1 -3.69127e-08 8.32715 6.84375)"/>
</clipPath>
<clipPath id="clip17_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(-3.69127e-08 1 1 3.69127e-08 9.33887 5.10938)"/>
</clipPath>
<clipPath id="clip18_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(-0.965926 -0.258819 -0.258819 0.965926 9.53955 6.68945)"/>
</clipPath>
<clipPath id="clip19_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(0.965926 0.258819 0.258819 -0.965926 8.12622 5.26367)"/>
</clipPath>
<clipPath id="clip20_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 7.86206 6.23145)"/>
</clipPath>
<clipPath id="clip21_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(-0.707107 0.707107 0.707107 0.707107 9.80371 5.7207)"/>
</clipPath>
<clipPath id="clip22_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(-0.258819 -0.965926 -0.965926 0.258819 8.5686 6.94434)"/>
</clipPath>
<clipPath id="clip23_26046_32588">
<rect width="1.7344" height="4.62506" fill="white" transform="matrix(0.258819 0.965926 0.965926 -0.258819 9.09692 5.00781)"/>
</clipPath>
</defs>
</svg>

`;
